/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Insert_Event_AboveInputs */



/**
* | output |
* | --- |
* | "Insert event above the currently selected event." |
*
* @param {Shortcut_Keys_Desc_Insert_Event_AboveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_insert_event_above = /** @type {((inputs?: Shortcut_Keys_Desc_Insert_Event_AboveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Insert_Event_AboveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inserer un evenement au-dessus de l'evenement selectionne.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Füge das Ereignis oberhalb des aktuell ausgewählten Ereignisses ein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci l'evento sopra l'evento attualmente selezionato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставьте событие выше текущего выбранного события.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar evento encima del evento actualmente seleccionado.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在当前选中事件上方插入事件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("現在選択されているイベントの上にイベントを挿入します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तमान में चयनित इवेंट के ऊपर एक और इवेंट डालें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Insira o evento acima do evento atualmente selecionado.")
	return /** @type {LocalizedString} */ ("Insert event above the currently selected event.")
});